// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhl_j bhl_i bhl_bc bhl_r bhl_st","QualityCheckboxes__quality":"ex_b"};